import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserAttribute, UserAttributes } from "shared-auth";
import { parseQuery } from "shared/utils/http";
import { UserManager } from "core";

function withArtistRef<P>(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<P>>
): React.FC<React.PropsWithChildren<P>> {
  return (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { artistref } = parseQuery(location.search);

    useEffect(() => {
      const performerId = getUserAttribute(UserAttributes.UserIdPerformer);

      UserManager.artistRef = performerId || artistref || UserManager.artistRef;

      if (artistref) navigate(location.pathname, { replace: true });
    }, [artistref, location.pathname]);

    return <WrappedComponent {...props} />;
  };
}

export default withArtistRef;
